import { render, staticRenderFns } from "./PxfModalContent.vue?vue&type=template&id=67af4f81&scoped=true"
import script from "./PxfModalContent.vue?vue&type=script&lang=js"
export * from "./PxfModalContent.vue?vue&type=script&lang=js"
import style0 from "./PxfModalContent.vue?vue&type=style&index=0&id=67af4f81&prod&lang=scss&scoped=true"
import style1 from "./PxfModalContent.vue?vue&type=style&index=1&id=67af4f81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af4f81",
  null
  
)

export default component.exports